import { zeroPad } from 'react-countdown-now';

const CountdownTimerRenderer = ({ days, hours, minutes, seconds, style, withDividers }) => (
	<div className={`clearfix ${style.timer}`}>
		<CountdownTimerPart {...{ number: zeroPad(days, 2), text: 'DAYS' }} />
		{ withDividers === true ? <div className={style.divider} /> : null }
		<CountdownTimerPart {...{ number: hours, text: 'HRS' }} />
		{ withDividers === true ? <div className={style.divider} /> : null }
		<CountdownTimerPart {...{ number: minutes, text: 'MIN' }} />
		{ withDividers === true ? <div className={style.divider} /> : null }
		<CountdownTimerPart {...{ number: seconds, text: 'SEC' }} />
	</div>
);

const CountdownTimerPart = ({ number, text }) => (
	<div className="part">
		<div className="number">{number}</div>
		<div className="text">{text}</div>
	</div>
);

export default CountdownTimerRenderer;


// WEBPACK FOOTER //
// ./components/countdown/CountdownTimerRenderer.js